import AmioHttpService from '@/services/amio/amio-http.service'

class BugReportService extends AmioHttpService {
  async submit(payload) {
    try {
      const response = await this.requestPost('/utils/bug-report', payload)
      return response.data
    } catch (err) {
      throw this.handleError(err)
    }
  }
}

export default new BugReportService()
